import React from 'react';
import {TextInputMaskProps} from 'react-native-text-input-mask';
import {useTheme} from 'styled-components/native';

import {Container, Label, InputField} from './styles';

interface IInput extends TextInputMaskProps {
  labelText?: string;
}

export function Input({labelText, ...rest}: IInput) {
  const theme = useTheme();
  return (
    <Container style={{}}>
      {labelText && <Label>{labelText}</Label>}
      <InputField {...rest} placeholderTextColor={theme.colors.placeholder} />
    </Container>
  );
}
